import PopoverBase from '../PopoverBase'

import './styles.scss'

export default class Popover extends PopoverBase {
  static defaultProps = {
    ...PopoverBase.defaultProps,
    interactive: true,
    type: 'popover',
  }
}
